import FormLayout from 'components/v2/FormLayout'
import Heading from 'components/v2/Heading'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { ReactElement, ReactNode, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useLogin } from 'features/Login/hooks'
import { canWrite } from 'features/Users/utils'
import { FormSteps } from 'components/v2/FormSteps'
import { useIntl } from 'react-intl'

interface IFormTemplateProps {
  tabTitle?: string
  title: string
  featureName: string
  children: ReactNode
  isEdit?: boolean
}

export const FormTemplate = ({ tabTitle, title, featureName, children, isEdit }: IFormTemplateProps): ReactElement => {
  const intl = useIntl()
  const login = useLogin()
  const [, setSearchParams] = useSearchParams()
  const canWriteOnFeature = canWrite(featureName, login.accessToken.policies)

  useEffect((): void => {
    document.title = tabTitle ?? title
    setSearchParams({}, { replace: true })
  }, [])

  if (!canWriteOnFeature) {
    return <ForbiddenView feature={featureName} />
  }

  return (
    <FormLayout.Container>
      <FormLayout.Content>
        <Heading.H3 capitalize>{title}</Heading.H3>
        <FormSteps
          steps={[
            intl.formatMessage({ id: `drivers.form.steps.1`, defaultMessage: 'Personal Information' }),
            intl.formatMessage({ id: `drivers.form.steps.2`, defaultMessage: 'Documents' })
          ]}
          isEdit={isEdit}
        />
        {children}
      </FormLayout.Content>
    </FormLayout.Container>
  )
}
